import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { QuoteService } from 'src/app/service/quote.service';

@Component({
  selector: 'quote-step11',
  templateUrl: 'quote-step11.component.html',
  styleUrls: ['quote-step11.component.css'],
})
export class QuoteStep11Component {
  
  @Input() screenWidth: number;
  @Input() currentStep: number;
  @Output() onNextStep: EventEmitter<number> = new EventEmitter();
  @Output() onPrevStep: EventEmitter<number> = new EventEmitter();

  stepElevenForm: FormGroup;
  submitted = false;
  
  constructor(private quoteService: QuoteService, private http: HttpClient, private fb: FormBuilder) {
    this.createForm();
  }

  createForm() {
      this.stepElevenForm = this.fb.group({
        dayBirth: ['', Validators.required],
          monthBirth: ['', Validators.required],
          yearBirth: ['', Validators.required],
          firstName: ['', Validators.required],
          lastName: ['', Validators.required],
          pasaportNo: ['', Validators.required],
          relationship: ['', Validators.required],
      });
      if (this.quoteService.quoteModel) {
        console.log(this.quoteService.quoteModel)
      } 
    }

  nextStep(stepNumber?: number): void {
		 this.onNextStep.emit(stepNumber ?? this.currentStep);
	}

  prevStep(stepNumber?: number): void {
    this.onPrevStep.emit(stepNumber ?? this.currentStep);
 }
}
